const CONFIGURACION_TESORERIA_HARDCODED_YPF = {
  idCuentaBancariaRetiroSobres: 6,
};

const getConfiguracionTesoreria = async () => {
  return CONFIGURACION_TESORERIA_HARDCODED_YPF;
};

const configuracionTesoreria = {
  getConfiguracionTesoreria,
};

export default configuracionTesoreria;
